import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "sorting-question-container"
};
const _hoisted_2 = {
  class: "question-preamble"
};
const _hoisted_3 = {
  class: "sorting-answers"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_items_sorting = _resolveComponent("items-sorting");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('chapter.question.sorting.title')), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_items_sorting, {
    "sorting-items": _ctx.sortingItems,
    onSortingItemsUpdate: _ctx.onSortingItemsUpdate
  }, null, 8, ["sorting-items", "onSortingItemsUpdate"])]), _createElementVNode("span", {
    class: "add-answer",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.addSortingItems())
  }, [_cache[1] || (_cache[1] = _createTextVNode(" + ", -1)), _createElementVNode("u", null, _toDisplayString(_ctx.$t('chapter.question.sorting.addAnswer')), 1)])]);
}